<template>
  <highcharts v-if="chartOptions" type="chart" :options="chartOptions" />
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  inject: ['redirectMissedToTrace', 'redirectInterventionsToTrace'],
  props: {
    options: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    chartIndex: {
      type: Number,
      default: -1,
      required: true,
    },
  },
  data() {
    return {
      chartOptions: null,
    };
  },

  computed: {
    ...mapGetters(['taskProcesses']),
  },

  mounted() {
    this.setChartOptions();
  },

  watch: {
    options: {
      handler(val) {
        this.setChartOptions();
      },
      deep: true,
    },
  },

  methods: {
    getMissedStepIndex(label) {
      let subSteps = [];
      this.taskProcesses.forEach((process) => {
        const processSubSteps = process.steps.reduce(
          (res, el) => [...res, ...el.substeps],
          []
        );
        subSteps = [...subSteps, ...processSubSteps];
      });
      return subSteps.indexOf(label);
    },

    getInterventionsIndex(label) {
      let subSteps = [];
      this.taskProcesses.forEach((process) => {
        const processSubSteps = process.steps.reduce(
          (res, el) => [...res, ...el.substeps],
          []
        );
        subSteps = [...subSteps, ...processSubSteps];
      });
      return subSteps.indexOf(label);
    },

    setChartOptions() {
      const { data, labels, interventions, xlabelString, ylabelString } =
        this.options;
      const self = this;
      this.chartOptions = {
        chart: {
          zoomType: 'xy',
          height: '70%',
          scrollablePlotArea: {
            minHeight: labels.length * 60,
            scrollPositionY: 0,
          },
          style: {
            padding: '0.5em',
          },
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        title: {
          text: '', //title,
        },
        legend: {
          enabled: true,
        },
        xAxis: {
          categories: labels,
          title: {
            text: xlabelString,
          },
        },

        yAxis: {
          title: {
            text: ylabelString,
          },
        },
        tooltip: {
          formatter: function () {
            const { x, y, series } = this;
            if (series.name === 'Missed Steps') {
              return `<b>${x}</b> missed in <b>${y}</b> cycle(s).`;
            } else if (series.name === 'Interventions') {
              return `Intervention(s) for <b>${x}</b> in <b>${y}</b> cycle(s).`;
            }
          },
        },

        series: [
          {
            name: 'Missed Steps',
            type: 'bar',
            data: data,
            cursor: 'pointer',
            point: {
              events: {
                click: function (e) {
                  self.redirectMissedToTrace({
                    missedSteps: [self.getMissedStepIndex(e?.point?.category)],
                    chartIndex: self.chartIndex,
                  });
                },
              },
            },
          },
          {
            name: 'Interventions',
            type: 'bar',
            data: interventions,
            cursor: 'pointer',
            // color: 'lightgray',
            point: {
              events: {
                click: function (e) {
                  self.redirectInterventionsToTrace({
                    interventions: [
                      self.getInterventionsIndex(e?.point?.category),
                    ],
                    chartIndex: self.chartIndex,
                  });
                },
              },
            },
          },
        ],
      };
    },
  },
};
</script>
